// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k","primary":"Button_primary__1mTxz","outlined":"Button_outlined__1slbo","icon":"Button_icon__23JL_","withoutText":"Button_withoutText__1Rta6"};